const actions = {
  SET_STATE: "license/SET_STATE",
  INFO: "license/INFO",
  REQUEST: "license/REQUEST",
  ASSIGN: "license/ASSIGN",
};

export default actions;
